class TilesHome {
  constructor() {
    this.tiles = Array.prototype.slice.call(document.querySelectorAll('.ns-tile'))
    if (window.innerWidth <= 992 && this.tiles.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.tiles.forEach((tile) => {
      tile.addEventListener('click', () => {
        if (tile.classList.contains('show-text')) {
          tile.classList.remove('show-text')
        } else {
          tile.classList.add('show-text')
        }
      })
    })
  }
}

export default TilesHome;
